$(document).ready(function () {
  // Initialize Cashfree
  const cashfree = Cashfree({
    mode: "production",
    // mode: "sandbox", // Change to "production" for live
  });

  // Global variables
  let currentOrderId = "";
  let currentPaymentSessionId = "";
  let currentPaymentInfo = null;

  const $dob = $('#dob');
  const datepicker = new Datepicker($dob[0], {
    format: 'dd-mm-yyyy'
  });

  const $hours = $("#hours");
  const $minutes = $("#minutes");
  const $ampm = $("#ampm");
  const $timeInput = $("#time");

  function updateHiddenTime() {
    let hours = parseInt($hours.val(), 10);
    const minutes = $minutes.val();
    const ampm = $ampm.val();

    let hours24 = hours;
    if (ampm === "PM" && hours !== 12) {
      hours24 += 12;
    } else if (ampm === "AM" && hours === 12) {
      hours24 = 0;
    }

    const formattedHours = hours24.toString().padStart(2, "0");
    const time = `${formattedHours}:${minutes}`;
    console.log(time);
    $timeInput.val(time);
  }

  $hours.on("change", updateHiddenTime);
  $minutes.on("change", updateHiddenTime);
  $ampm.on("change", updateHiddenTime);

  /*$("#birthPlace").on("input", function () {
    let birthPlaceValue = $(this).val().replace(/[^a-zA-Z\s]/g, "");
    const $cityNameProcess = $("#cityNameProcess");
    const $timeZonesValue = $("#timeZonesValue");

    $cityNameProcess.html("<small>Enter Village, Block or City Name here<small>");

    if (birthPlaceValue.length > 3) {
      $cityNameProcess.html('<b style="color:green;">Loading address details...<b>');

      const apiUrl = `https://api.mapbox.com/search/geocode/v6/forward?q=${birthPlaceValue}&proximity=ip&access_token=pk.eyJ1IjoidGVjaGFzdHJvYXJ1biIsImEiOiJjbTd2dHYwbDQwMDBvMmpyMTAweW9rMGFrIn0.S3g_9l651onCSCGNVvbtXw`;

      $.getJSON(apiUrl)
        .done(function (data) {
          console.log(data);
          $timeZonesValue.empty();

          const suggestions = data.features.map(result => ({
            address: result.properties.full_address,
            coordinates: [result.properties.coordinates.latitude, result.properties.coordinates.longitude],
          }));

          if (suggestions.length > 0) {
            suggestions.forEach(suggestion => {
              const $option = $("<li>")
                .html(suggestion.address)
                .attr({
                  "data-latitude": suggestion.coordinates[0],
                  "data-longitude": suggestion.coordinates[1],
                  "data-place": suggestion.address
                })
                .on("click", function () {
                  const $sBox = $("#birthPlace");
                  $sBox.val(suggestion.address)
                    .attr("data-latitude", suggestion.coordinates[0])
                    .attr("data-longitude", suggestion.coordinates[1])
                    .attr("data-place", suggestion.address);
                  $timeZonesValue.html("");
                });
              $timeZonesValue.append($option);
            });
          } else {
            $cityNameProcess.html("<small>No results found</small>");
          }
        })
        .fail(function (jqXHR, textStatus, errorThrown) {
          console.error("Error fetching address details:", errorThrown);
          $cityNameProcess.html("<small>Error loading address details</small>");
        });
    }
  });*/

  // API configuration
  const API_CONFIG = {
    baseUrl: "https://reportsapi.astroarunpandit.org/api/gems",
    token: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcHBJZCI6ImFhcC0wMDEtMTcwMzIwMjUiLCJlbnYiOiJwcm9kdWN0aW9uIiwidHlwZSI6InBlcm1hbmVudF9hY2Nlc3MiLCJ2ZXJzaW9uIjoiMS4wIiwiaXNzdWVkQXQiOiIyMDI1LTAzLTE3VDA2OjAyOjE1LjUwOVoiLCJpYXQiOjE3NDIxOTEzMzV9.XotwjWoKglVFW25gEirkOwB3ZZTpxngxhunpmok3hPM",
    returnUrl: window.location.origin + window.location.pathname,
  };

  const countryData = "https://cdn.shopify.com/s/files/1/0648/0514/2781/files/country_code_and_details.json";
  $.getJSON(countryData)
    .done(function (data) {
      const $countryCode = $("#country-code");
      $countryCode.empty();

      const countries = data.countries || [];
      countries.forEach(country => {
        const $option = $("<option>")
          .val(`+${country.phone_code}`)
          .text(`${country.country_code} (+${country.phone_code})`);

        if (country.country_code === "IN") {
          $option.prop("selected", true);
        }

        $countryCode.append($option);
      });
    })
    .fail(function (jqXHR, textStatus, errorThrown) {
      console.error("Error fetching JSON data:", errorThrown);
    });

  $("#consultation-form").on("submit", async function (event) {
    event.preventDefault();

    if (!validatePurpose()) {
      return;
    }

    const name = $.trim($("#name").val());
    const email = $.trim($("#email").val());
    const phone = $.trim($("#phone").val());
    const countryCode = $("#country-code").val();
    const birthDate = $("#dob").val();
    const birthTime = $("#time").val();
    const birthPlace = $.trim($("#birthPlace").val());
    const birthLat = $("#birthPlace").attr("data-latitude");
    const birthLong = $("#birthPlace").attr("data-longitude");
    const purpose = $("#purpose").val();

    const dateArr = birthDate.split("-");
    const formattedDate = `${dateArr[2]}/${dateArr[1]}/${dateArr[0]}`;

    const phoneRegex = /^[0-9]{10}$/;

    if (!name) return alert("Name is required.");
    if (!email.includes("@") || !email.includes(".")) return alert("Please enter a valid email address.");
    if (!phoneRegex.test(phone)) return alert("Phone number must be 10 digits.");
    if (!birthDate) return alert("Birth date is required.");
    if (!birthPlace) return alert("Birth place is required.");

    const urlParams = {
      name,
      email,
      phone_number: countryCode + phone,
      date_of_birth: formattedDate,
      time_of_birth: birthTime,
      place_of_birth: birthPlace,
      purpose_of_consultation: purpose,
      source_type: "gems_web"
    };

    const $button = $('.consultation-form button[type="submit"]');
    $button.addClass('loading').prop('disabled', true);

    const apiEndpoint = API_CONFIG.baseUrl + '/create-consultation';
    const authToken = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcHBJZCI6ImFhcC0wMDEtMTcwMzIwMjUiLCJlbnYiOiJwcm9kdWN0aW9uIiwidHlwZSI6InBlcm1hbmVudF9hY2Nlc3MiLCJ2ZXJzaW9uIjoiMS4wIiwiaXNzdWVkQXQiOiIyMDI1LTAzLTE3VDA2OjAyOjE1LjUwOVoiLCJpYXQiOjE3NDIxOTEzMzV9.XotwjWoKglVFW25gEirkOwB3ZZTpxngxhunpmok3hPM";

    await $.ajax({
        url: apiEndpoint,
        method: "POST",
        headers: {
          Authorization: `Bearer ${authToken}`,
          "Content-Type": "application/json"
        },
        data: JSON.stringify(urlParams)
      })
      .done(async function (response) {
        if (response.status === "already_registered") {
          $("#errorText").text("You have already registered for a consultation. Please check your email for details.");
          $("#errorMessage").show();
        } else {
          // Store IDs and show success message
          currentPaymentSessionId = response.paymentSessionId;
          currentOrderId = response.orderId;
          localStorage.setItem("lastOrderId", response.orderId);
          localStorage.setItem("lastSessionId", response.paymentSessionId);

          // Show success message briefly before redirecting
          // $("#consultation-form").hide();
          // $("#successMessage").show();

          // Immediately redirect to Cashfree
          let checkoutOptions = {
            paymentSessionId: response.paymentSessionId,
            redirectTarget: "_self",
            returnUrl: API_CONFIG.returnUrl + "?order_id=" + currentOrderId,
          };

          setTimeout(async function () {
            await cashfree.checkout(checkoutOptions);
          }, 1000); // Short delay to let user see success message
        }
      })
      .fail(function (xhr) {
        try {
          const errorResponse = JSON.parse(xhr.responseText);
          $("#errorText").text(errorResponse.message || "There was an error processing your request.");
        } catch (e) {
          $("#errorText").text("There was an error processing your request. Please try again.");
        }
        $("#errorMessage").show();
      })
      .always(function () {
        $button.removeClass('loading').prop('disabled', false);
      });
  });

  $('#newConsultationBtn').click(function (e) {
    e.preventDefault();

    $('#successSection, #successModal').hide();
    document.getElementById('consultation-form').reset();

    const countryCodeSelect = document.getElementById("country-code");
    countryCodeSelect.value = "+91";
    countryCodeSelect.dispatchEvent(new Event("change", {
      bubbles: true
    }));

    const newUrl = window.location.origin + window.location.pathname;
    window.history.replaceState({}, document.title, newUrl);
  });

  const urlParams = new URLSearchParams(window.location.search);
  const orderId = urlParams.get('order_id');
  if (orderId) {
    verifyAndUpdateStatus(orderId);
  }

  // Verify and automatically update payment status
  function verifyAndUpdateStatus(orderId) {
    $('#successSection, #successModal').hide();

    // First get the payment status
    apiCall(`/payment-status/${orderId}`, "GET")
      .done(function (response) {
         displayPaymentResult(response);
      })
      .fail(function () {
        $("#paymentLoadingStatus").hide();
        $("#paymentResult").show();
        $("#paymentResultTitle").text("Unable to Verify Payment");
        $("#paymentResultMessage").text("We couldn't verify your payment status. Please check the status tab for updates.");
      });
  }

  // Helper function for API calls with authorization
  function apiCall(endpoint, method, data = null) {
    const url = `${API_CONFIG.baseUrl}${endpoint}`;
    const options = {
      url: url,
      type: method,
      headers: {
        Authorization: `Bearer ${API_CONFIG.token}`,
        "Content-Type": "application/json",
      },
    };

    if (data) {
      options.data = JSON.stringify(data);
    }

    return $.ajax(options);
  }

  // Display payment result
  function displayPaymentResult(response) {
    $('#successOrderId').text(response.orderId);
    $('#successSection, #successModal').show();
    $('#success-icon, #failed-icon, #pending-icon').hide();

    if (response.status === "success") {
      $('#success-icon').show();
      $("#paymentResultTitle").text("Payment Successful");
      $("#paymentResultMessage").text("Your payment has been completed successfully. Our expert will reach out to you within 1 Working Day to begin your consultation.");
    } else if (response.status === "pending" || response.status === "created") {
      $('#pending-icon').show();
      $("#paymentResultTitle").text("Payment Processing");
      $("#paymentResultMessage").text("Processing your payment. Please hold tight while we finalize the transaction.");
    } else if (response.status === "cancelled") {
      $('#failed-icon').show();
      $("#paymentResultTitle").text("Payment Rejected");
      $("#paymentResultMessage").text("");
    } else {
      $('#failed-icon').show();
      $("#paymentResultTitle").text("Payment Failed");
      $("#paymentResultMessage").text("Something went wrong with your payment. Please try again.");
    }
  }

  function validatePurpose() {
    const $textarea = $("#purpose");
    const text = $textarea.val().trim();
    const wordCount = text.split(/\s+/).filter(word => word.length > 0).length;
    
    if (wordCount < 10) {
      $("#purpose-error").show();
      return false;
    } else {
      $("#purpose-error").hide();
      return true;
    }
  }
  
  $("#purpose").on("input change", validatePurpose);
});